import Accordion, { AccordionContent, AccordionItem, AccordionTrigger } from '@cobliteam/ui/components/Accordion';
import Tag from '@cobliteam/ui/components/Tag';
import Typography from '@cobliteam/ui/components/Typography';
import Icon from '@cobliteam/ui/icons';
import { memo } from 'react';

interface CategoryAccordionProps {
  title: string;
  description: string;
  children: React.ReactNode;
  totalActivationTasks: number;
  checkedActivationTasks: number;
  image?: string | null;
}

const CategoryAccordion = ({ title, description, children, totalActivationTasks, checkedActivationTasks, image }: CategoryAccordionProps) => {
  return (
    <Accordion type='single' collapsible defaultValue={checkedActivationTasks !== totalActivationTasks ? `category-${title}` : undefined}>
      <AccordionItem value={`category-${title}`}>
        <AccordionTrigger>
          <div className='flex flex-col gap-2'>
            <div className='flex flex-row items-center gap-2'>
              <Typography variant='text-lg-semibold'>{title}</Typography>
              {checkedActivationTasks !== totalActivationTasks ? (
                <Tag variant='outlined' color='primary' size='condensed' label={`${checkedActivationTasks}/${totalActivationTasks}`} />
              ) : (
                <Icon name='check' color='primary' />
              )}
            </div>
            <Typography variant='text-md' color='secondary'>
              {description}
            </Typography>
          </div>
        </AccordionTrigger>
        <AccordionContent className='flex flex-col gap-4'>
          {image && <img src={image} alt={title} className='mx-auto max-w-md rounded-lg object-cover' />}
          <div className='flex flex-col gap-4'>{children}</div>
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
};

export default memo(CategoryAccordion);
